// HINT: new future button component make it global
import classnames from 'classnames';
import Icon from 'components/ui/icon';
import Loader from 'components/ui/loader';
import './newButton.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
}

export const NewButton: React.FC<Props> = ({
  isLoading,
  disabled,
  children,
  ...props
}) => {
  return (
    <button
      className={classnames('new-button', { 'new-button_loading': isLoading })}
      disabled={disabled || isLoading}
      {...props}>
      <div className='new-button__content'>
        {children}
        <span className='new-button__icon'>
          {isLoading ? (
            <Loader isInternal />
          ) : (
            <Icon name='im-Arrow-right-Option-2' size={14} />
          )}
        </span>
      </div>
    </button>
  );
};
